<template>
	<div class="variable-creator">
        <p>{{$t('methods.new-method')}}</p>
            <div class="form-group">
                <label for="varType">{{$t('extra-variables.type-label')}}</label>
                <br/>
                <div class="radio-btns">
                <label for="option1" class="container">
                <input type="radio" id="option1" value="option1" v-model="selectedType">
                <div class="check-indicator"></div>
                    <span>Standard</span></label>

                <label for="option2" class="container">
                <input type="radio" id="option2" value="option2" v-model="selectedType">
                <div class="check-indicator"></div>
                    <span>{{$t('extra-variables.if')}}</span></label>

                <label for="option3" class="container">
                <input type="radio" id="option3" value="option3" v-model="selectedType">
                <div class="check-indicator"></div>
                    <span>{{$t('extra-variables.dictionary')}}</span></label>
                </div>
            </div>

            <form @submit.stop.prevent v-if="selectedType == 'option1' || selectedType == 'option2'"> 
                <custom-input  :inputType="'text'" v-model="templateMethod.name" :name="'exraVariableName'" :label="$t('extra-variables.name')" :placeholder="$t('methods.method-name-placeholder')" :focusInputField="true" :invalidInput="invalid"/>
                <span v-if="invalid" class="text-danger small">{{$t('extra-variables.error-txt')}}</span>
                <custom-input v-if="selectedType == 'option1'" :inputType="'text'" v-model="templateMethod.expression" :name="'exraVariableExpression'" :label="$t('extra-variables.expression')" :placeholder="$t('extra-variables.expression-placeholder')" :optionBtn="true" :btnText="$t('extra-variables.add-var-btn')" @option-btn-clicked="$emit('get-variable-groups'), stagedInputField = 'expression'"/>
                
                <div v-if="selectedType == 'option2'" >
                    <custom-input :inputType="'text'" v-model="templateMethod.if" :name="'exraVariableIfStatement'" :label="$t('extra-variables.if')" :placeholder="$t('extra-variables.if')" :optionBtn="true" :btnText="$t('extra-variables.add-var-btn')" @option-btn-clicked="$emit('get-variable-groups'), stagedInputField = 'if'"/>
                    <custom-input :inputType="'text'" v-model="templateMethod.then" :name="'exraVariableThenStatement'" :label="$t('extra-variables.then')" :placeholder="$t('extra-variables.then')" :optionBtn="true" :btnText="$t('extra-variables.add-var-btn')" @option-btn-clicked="$emit('get-variable-groups'), stagedInputField = 'then'"/>

                   <div  :class="{'fold-in': elseAnimation, 'fold-out': elseIfLevel}" >
                        <div v-if="elseIfLevel">
                            <custom-input :inputType="'text'" v-model="templateMethod.elseIf" :name="'exraVariableElseIfStatement'" :label="$t('extra-variables.else-if')" :placeholder="$t('extra-variables.else-if') + '..'" :optionBtn="true" :btnText="$t('extra-variables.add-var-btn')" @option-btn-clicked="$emit('get-variable-groups'), stagedInputField = 'elseIf'"/>
                            <custom-input :inputType="'text'" v-model="templateMethod.elseIfThen" :name="'exraVariableElseIfThenStatement'" :label="$t('extra-variables.then')" :placeholder="$t('extra-variables.then')" :optionBtn="true" :btnText="$t('extra-variables.add-var-btn')" @option-btn-clicked="$emit('get-variable-groups'), stagedInputField = 'elseIfThen'"/>
                        </div>
                        <div class="extend-btn" @click="toggleExtendedIfElse">{{elseIfLevel ? $t('extra-variables.remove') : $t('extra-variables.extend')}} </div>
                   </div>
                   
                    <custom-input :inputType="'text'" v-model="templateMethod.else" :name="'exraVariableElseStatement'" :label="$t('extra-variables.else')" :placeholder="$t('extra-variables.else-placeholder')" :optionBtn="true" :btnText="$t('extra-variables.add-var-btn')" @option-btn-clicked="$emit('get-variable-groups'), stagedInputField = 'else'"/>
                </div>

                <div class="form-group" v-if="selectedType == 'option1' || selectedType ==  'option2'">
                    <label for="formatType" :class="{'hide': !templateMethod.type}"   style="margin-bottom: 0; margin-top: 10px;">Output type</label>
                    <select name="formatType" class="form-control selector" v-model="templateMethod.type" required> 
                        <option disabled value="">Output type</option>
                        <option value="Text">{{$t('extra-variables.text')}}</option>
                        <option value="Number">{{$t('extra-variables.number')}}</option>
                        <option value="List">{{$t('extra-variables.list')}}</option>
                        <option value="Timespan">{{$t('extra-variables.timespan')}}</option>
                    </select>
                </div>
                <div class="actions">
                    <button v-if="selectedType" :disabled="!valid" @click="exportExtraVariable" class="btn btn-primary">{{$t("extra-variables.create")}}</button>
                </div>
            </form>
            <div class="dictionary" v-if="selectedType == 'option3'">
                <form  @submit.stop.prevent>
                    <custom-input  :inputType="'text'" v-model="dictionary.name" :name="'dictionaryName'" :label='$t("extra-variables.name")' :placeholder="$t('methods.method-name-placeholder')" :focusInputField="true" :invalidInput="invalid"/>
                    <span v-if="invalid" class="text-danger small">{{$t('extra-variables.error-txt')}}</span>              
               
                    <custom-input  style="margin-bottom:24px;"  :inputType="'text'" v-model="dictionary.expression" :name="'dictionaryExpression'" :label="$t('extra-variables.expression')" :placeholder="$t('extra-variables.expression-placeholder')" :optionBtn="true" :btnText="$t('extra-variables.add-var-btn')" @option-btn-clicked="$emit('get-variable-groups'), stagedInputField = 'expression'"/>

                    <dictionary-adder :mappings="mappings" :focusInput="false" />

                    <div class="mappings">
                        <div class="mapping" v-for="(map, index) in mappings" :key="index"> 
                            <div class="row">
                                <custom-input class="col-lg-5 arrow"  :inputType="'text'" v-model="map.string" :name="`mapString${index}`" :label="'String'"/>
                                <custom-input class="col-lg-6"  :inputType="'text'" v-model="map.expression" :name="`mapExpression${index}`" :label="'Expression'"/>
                                <button type="button" class="btn col-lg-1" @click="removeMapping(map, index)"><img src="@/assets/svg/trash-button-no-circle.svg" /></button>
                            </div>
                        </div>
                    </div>
                    <div class="actions">
                        <button v-if="selectedType" :disabled="!valid" @click="exportExtraVariable" class="btn btn-primary">{{$t("extra-variables.create")}}</button>
                    </div>
                </form>
            </div>
    </div>
</template>

<script>
import CustomInput from "@/components/CustomInput";
import CustomPopover from '@/components/CustomPopover';
import EditExtraVariable from '@/components/EditExtraVariable';
import VariableSelector from '@/components/VariableSelector'
import DictionaryAdder from "@/components/DictionaryAdder";
import EventBus from "@/assets/js/eventBus.js";
export default {
  name: "createTemplateMethod",
  props:{
      templateMethods: Array
  },
  data() {   
    return {
    templateMethod: {
        name: "",
        expression: "",
        type: "",
        if: "",
        then:"",
        elseIf: "",
        elseIfThen: "",
        else: ""
    },
    dictionary: {
        name: "",
        expression: "",
        mappings: {},
        else: ""
    },
    mappings: [],
    selectedType: "option1",
    invalid: false,
    elseIfLevel: false,
    elseAnimation: false,
    stagedInputField: null
    }

  },
  computed:{
        valid(){
        if(this.selectedType == 'option1') return (this.templateMethod.name && this.templateMethod.expression && this.templateMethod.type) 
        if(this.selectedType == 'option2') return (this.templateMethod.name && this.templateMethod.if && this.templateMethod.then && this.templateMethod.type) 
        if(this.selectedType == 'option3') return (this.dictionary.name && this.dictionary.expression && this.mappings.length != 0 ) 
        else return false
    },
  },
  methods:{
       exportExtraVariable(){
        // this.templateMethod.name = "{extra-variables_" + this.templateMethod.name + '}'
        let newTemplateMethod;
        if(this.selectedType == 'option1'){
            newTemplateMethod = {
                name: this.templateMethod.name,
                expression: this.templateMethod.expression,
                type: this.templateMethod.type
            }
        }
        if(this.selectedType == 'option2'){
            newTemplateMethod = {
                name: this.templateMethod.name,
                if: this.templateMethod.if,
                then: this.templateMethod.then,
                type: this.templateMethod.type
            }
            if(this.templateMethod.else != null){
                newTemplateMethod.else = this.templateMethod.else
            }
            if(this.elseIfLevel == true){
                newTemplateMethod.elseIf = this.templateMethod.elseIf
                newTemplateMethod.elseIfThen = this.templateMethod.elseIfThen
            }
        }
        if(this.selectedType == 'option3'){
            let formattedMapping = {}
            this.mappings.forEach(mapping => {
                formattedMapping[mapping.string] = mapping.expression
            });
            newTemplateMethod = {
            name: this.dictionary.name,
            expression: this.dictionary.expression,
            mappings: formattedMapping, 
            else: this.dictionary.expression,
            type: "Text"
        }
        }
        
        newTemplateMethod.name = newTemplateMethod.name.replace(/ /g, '-')

        // check if name is a duplicate - only checks in other templateMethods, doesnt look for duplicates in all variables.
        if(!this.templateMethods.some(v => v.name == newTemplateMethod.name  )){
            console.log("non duplicate")
            this.$store.state.template.methods.push(newTemplateMethod)
            this.$store.state.unsavedChanges = true
            this.createVariableClicked = false
            this.templateMethod = false
            this.selectedType = null
            this.invalid = false
            this.$emit('create-and-close')
        } else{ 
            console.log("duplicate")
            this.invalid = true
        }
     },
    addToExpression(variable){
        if(this.selectedType == 'option3'){
        this.dictionary[this.stagedInputField] = variable 
        this.stagedInputField = null
        } else {
            this.templateMethod[this.stagedInputField] = this.templateMethod[this.stagedInputField] + variable 
            this.stagedInputField = null
        } 
    },
    toggleExtendedIfElse(){
        if(!this.elseIfLevel) this.elseIfLevel = !this.elseIfLevel
        else{
            this.elseAnimation = !this.elseAnimation
            setTimeout( ()=> {
                this.elseIfLevel = !this.elseIfLevel
                this.elseAnimation = !this.elseAnimation
                }, 150)
        }
    },
    addMappingToMappings(){
        console.log(this.newMap)
        let mapEntry = {
            string: this.newMap.string,
            expression: this.newMap.expression
        }
        this.mappings.push(mapEntry)
        this.newMap.string = ''
        this.newMap.expression = ''
    },
    removeMapping(mapping, index){
        this.mappings.splice(index, 1)
        this.changesDetected = true
    }
  },
  mounted(){
    EventBus.$on('add-to-expression', this.addToExpression)
  },
  destroyed(){
    EventBus.$off('add-to-expression')
  },
  components:{
      CustomInput,
      DictionaryAdder
  }

}
</script>

<style lang="less">
      .variable-creator{
                margin: 12px;
                margin-bottom: 42px;

                p{
                    font-size: 18px;
                    font-weight: bolder;
                }

                .extend-btn{
                    border: none;
                    background: inherit;
                    color: var(--orange-web);
                    font-size: 12px;
                    cursor: pointer;
                }

                .actions{
                    display: flex;
                    justify-content: flex-end;

                    .btn-primary{
                        margin: 10px 0 0 0;
                    }
                }
                .fold-out{
                   animation: foldOut .4s ease ;
                }
                .fold-in{
                   animation: foldIn .2s ease ;
                }
                @keyframes foldOut {
                from{
                    transform: translateY(-30px);
                    opacity: 0.6;
                }
                to{
                    transform: translateX(0);
                    opacity: 1;
                }      
            }

                   @keyframes foldIn {
                from{
                    transform: translateX(0);
                    opacity: 1;
                    }
                to{
                    transform: translateY(-30px);
                    opacity: 0.6;
                }

            }

    .mappings{
        padding: 0 12px 12px 12px;
        button{
            z-index: 1;
            padding: 0;
            margin-top: 30px;
            padding-right: 10px;  
        }
    }
        .arrow::after{
            content: "→";
            position: absolute;
            right: -8px;
            top: 40px;
        }

    .dictionary-group{
        margin-top: 12px;
        display: flex;
        flex-direction: column;
        button{
            height: 36px;
            width: max-content;
            &:hover{
            box-shadow: 5px 4px 4px 2px rgba(0, 0, 0, 0.25); 
            }
        }
    }


    .radio-btns{
        // display: flex;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        padding-top: 12px;

        .container {
            display: block;
            position: relative;
            padding: 0;
            cursor: pointer;
            font-size: 22px;
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;

            input {
                
                position: absolute;
                opacity: 0;
                cursor: pointer;

                &:checked ~ .check-indicator {
                background-color: var(--orange-web);
                }

                &:checked ~ .check-indicator:after {
                display: block;
                }     
                &:checked ~ span{
                    color: #495057; ;
                }
            }
            &:hover input ~ .check-indicator {
                filter: brightness(1.05);
            }

            .check-indicator {
                position: absolute;
                top: 0;
                left: 0;
                height: 18px;
                width: 18px;
                background-color: #e2e2e2;
                border-radius: 50%;


                &:after {
                content: "";
                position: absolute;
                display: none;
                }

                &:after {
                top: 6px;
                left: 6px;
                width: 6px;
                height: 6px;
                border-radius: 50%;
                background: white;
                }
            }

            span{
            margin-left: 24px;
            }
        }
    }

}
</style>


